import { render, staticRenderFns } from "./salesGoods.vue?vue&type=template&id=5477b41c&scoped=true&"
import script from "./salesGoods.vue?vue&type=script&lang=js&"
export * from "./salesGoods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5477b41c",
  null
  
)

export default component.exports